// extracted by mini-css-extract-plugin
export var animationAbsolute = "_24-e";
export var animationRelative = "_24-d";
export var backdropBlur = "_24-0";
export var detailLabelCell = "_24-q";
export var detailTable = "_24-p";
export var detailValueCell = "_24-r";
export var documentTypeIcon = "_24-y";
export var documentTypeOption = "_24-x";
export var dropdownMatchDatePicker = "_24-3";
export var evidenceCardContent = "_24-w";
export var gorgiasTicketCard = "_24-s";
export var iconTertiary = "_24-z";
export var integrationCard = "_24-1";
export var integrationLogoBox = "_24-2";
export var mainColumnSticky = "_24-v";
export var maxWidthContainer = "_24-t";
export var modalContentBody = "_24-a";
export var modalHeaderImage = "_24-5";
export var modalImageLabel = "_24-7";
export var modalImageOverlay = "_24-6";
export var modalImageSubtitle = "_24-9";
export var modalImageTitle = "_24-8";
export var modalImageWrapper = "_24-4";
export var modalStickyFooter = "_24-b";
export var sidebarColumn = "_24-u";
export var timelineLine = "_24-m";
export var timelineLineBlack = "_24-o _24-m";
export var timelineLineGray = "_24-n _24-m";
export var timelineLineHeight = "_24-l";
export var tlDotActivate = "_24-i";
export var tlDotActivateAnim = "_24-h";
export var tlDotHide = "_24-g";
export var tlDotHideAnim = "_24-f";
export var tlLineActivate = "_24-k";
export var tlLineActivateAnim = "_24-j";
export var uploadedFileRow = "_24-c";